"use strict";
exports.__esModule = true;
exports.ILLEGAL_LENGTH = 'Illegal trits length';
exports.ILLEGAL_TRIT_CONVERSION_INPUT = 'Illegal conversion input. Expected trits as Int8Array.';
exports.ILLEGAL_TRYTE_CONVERSION_INPUT = 'Illegal conversion input. Expected trytes string or integer.';
exports.INCONSISTENT_SUBTANGLE = 'Inconsistent subtangle';
exports.INSUFFICIENT_BALANCE = 'Insufficient balance';
exports.INVALID_ADDRESS = 'Invalid address';
exports.INVALID_REMAINDER_ADDRESS = 'Invalid remainder address';
exports.INVALID_BRANCH_TRANSACTION = 'Invalid branch transaction';
exports.INVALID_BUNDLE = 'Invalid bundle';
exports.INVALID_BUNDLE_HASH = 'Invalid bundle hash';
exports.INVALID_CHECKSUM = 'Invalid checksum';
exports.INVALID_COMMAND = 'Invalid command format';
exports.INVALID_DEPTH = 'Invalid depth';
exports.INVALID_HASH = 'Invalid hash';
exports.INVALID_INDEX = 'Invalid index option';
exports.INVALID_TOTAL_OPTION = 'Invalid total option';
exports.INVALID_INPUT = 'Invalid input';
exports.INVALID_KEY = 'Invalid key value';
exports.INVALID_MIN_WEIGHT_MAGNITUDE = 'Invalid Min Weight Magnitude';
exports.INVALID_SEARCH_KEY = 'Invalid search key';
exports.INVALID_SECURITY_LEVEL = 'Invalid security option';
exports.INVALID_SECURITY_OPTION = 'Invalid security option';
exports.INVALID_SEED = 'Invalid seed';
exports.INVALID_START_END_OPTIONS = 'Invalid end option';
exports.INVALID_START_OPTION = 'Invalid start option';
exports.INVALID_TAG = 'Invalid tag';
exports.INVALID_TRANSACTION = 'Invalid transaction';
exports.INVALID_TRANSACTION_TRYTES = 'Invalid transaction trytes';
exports.INVALID_ATTACHED_TRYTES = 'Invalid attached trytes';
exports.INVALID_TRANSACTION_HASH = 'Invalid transaction hash';
exports.INVALID_TAIL_TRANSACTION = 'Invalid tail transaction';
exports.INVALID_THRESHOLD = 'Invalid threshold option';
exports.INVALID_TRANSFER = 'Invalid transfer object';
exports.INVALID_TRUNK_TRANSACTION = 'Invalid trunk transaction';
exports.INVALID_REFERENCE_HASH = 'Invalid reference hash';
exports.INVALID_TRYTES = 'Invalid trytes';
exports.INVALID_URI = 'Invalid uri';
exports.INVALID_ASCII_INPUT = 'Conversion to trytes requires type of input to be encoded in ascii.';
exports.INVALID_ODD_LENGTH = 'Conversion from trytes requires length of trytes to be even.';
exports.INVALID_TRYTE_ENCODED_JSON = 'Invalid tryte encoded JSON message';
exports.NOT_INT = 'One of the inputs is not integer';
exports.SENDING_BACK_TO_INPUTS = 'One of the transaction inputs is used as output.';
exports.INVALID_TRANSACTIONS_TO_APPROVE = 'Invalid transactions to approve.';
exports.NO_INPUTS = 'Could not find any available inputs.';
exports.invalidChecksum = function (address) { return "Invalid Checksum: " + address; };
exports.inconsistentTransaction = function (reason) { return "Transaction is inconsistent. Reason: " + reason; };
//# sourceMappingURL=errors.js.map